import { useCallback, useEffect, useState } from 'react';
import * as api from '../api';
import PageHeader from '../components/ui/PageHeader';
import PageCard from '../components/ui/PageCard';
import FormField from '../components/ui/FormField';
import Switch from '../components/ui/Switch';
import ErrorMessage from '../components/ui/ErrorMessage';
import Loader from '../components/ui/Loader';
import './CrudPage.scss';
import './SiteStatusPage.scss';

export default function SiteStatusPage() {
    const [available, setAvailable] = useState(true);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const load = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const data = await api.getSiteStatus();
            setAvailable(Boolean(data.available));
            setMessage(data.message || '');
        } catch (err) {
            setError(err.message || 'Ошибка загрузки');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const handleSave = async () => {
        setSaving(true);
        setError('');
        setSuccess('');
        try {
            const data = await api.updateSiteStatus({
                available,
                message: message.trim() || null,
            });
            setAvailable(Boolean(data.available));
            setMessage(data.message || '');
            setSuccess('Статус сайта обновлён');
        } catch (err) {
            setError(err.message || 'Ошибка сохранения');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <Loader text="Загружаем статус..." />;
    }

    return (
        <div className="crud-page">
            <PageHeader
                title="Статус сайта"
                subtitle="Режим обслуживания для пользовательского фронтенда"
            />

            <ErrorMessage message={error} onRetry={load} />
            {success && <div className="form-banner">{success}</div>}

            <PageCard>
                <div className="site-status-toggle">
                    <div className="site-status-toggle__info">
                        <span className="site-status-toggle__title">Доступность сайта</span>
                        <span className="site-status-toggle__hint">
                            {available
                                ? 'Пользователи видят личный кабинет как обычно'
                                : 'Вместо приложения показывается страница техработ'}
                        </span>
                        <span className={`site-status-toggle__badge site-status-toggle__badge--${available ? 'available' : 'maintenance'}`}>
                            {available ? 'Доступен' : 'Техработы'}
                        </span>
                    </div>
                    <Switch
                        checked={available}
                        onChange={(next) => {
                            setAvailable(next);
                            setSuccess('');
                        }}
                    />
                </div>

                <FormField
                    label="Сообщение при недоступности"
                    value={message}
                    onChange={(e) => {
                        setMessage(e.target.value);
                        setSuccess('');
                    }}
                    placeholder="Ведутся технические работы..."
                    hint="Показывается пользователям, когда сайт недоступен"
                    disabled={available}
                />

                <button type="button" className="btn btn--primary" onClick={handleSave} disabled={saving}>
                    {saving ? 'Сохранение...' : 'Сохранить'}
                </button>
            </PageCard>
        </div>
    );
}
